import { SxProps, Theme, FormHelperText } from '@mui/material'
import { EditLocationAlt } from '@mui/icons-material'
import { useTexts } from './useTexts'

export function PositionAdjusted() {
  const texts = useTexts()

  return (
    <FormHelperText sx={sx}>
      <EditLocationAlt sx={{ pr: 0.5, fontSize: '1rem' }} color="primary" />
      {texts.positionAdjusted}
    </FormHelperText>
  )
}

const sx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  color: t => t.vars.palette.text.secondary,
  ml: t => t.spacing(1.5),
}
